export const NewsHeader = (() => {
	'use strict';

	function init() {
		const $rows = document.querySelectorAll('[data-resource]')
		const $categoryBlock = document.querySelector('.pxblock--news.type-category')
		const $newsBlock = document.querySelector('.pxblock--news.type-news-feed')
		const $headerBlock = document.querySelector('.pxblock--news-header')
		const $headerIntro = document.querySelector('[data-resource-intro]')
		const $headerFiltered = document.querySelector('[data-resource-filtered]')
		const $showMore = document.querySelector('[data-resource-show-more]')
		if (!$rows.length || !$headerBlock || !$categoryBlock) {
			return
		}
		const MAX_SHOW = 8
		const categories = {}
		const tags = {}
		let showAll = false

		const eachRow = (cb) => {
			for (let i = 0; i < $rows.length; i++) {
				cb($rows[i])
			}
		}

		const initData = () => {
			const taxonomy = [categories, tags]
			eachRow(($row) => {
				const attrSplit = $row.getAttribute('data-resource').split('|||')
				for (let x = 0; x < 2; x++) {
					const tax = taxonomy[x]
					attrSplit[x].split('||').forEach((val) => {
						val = val.split('|')
						const slug = val[0]
						const name = val[1]
						if (slug) {
							if (tax[slug]) {
								tax[slug].rows.push($row)
							} else {
								tax[slug] = {
									name,
									rows: [$row]
								}
							}
						}
					})
				}
			})
		}

		const doFilter = (filter) => {
			let showCount = 0
			eachRow(($row) => {
				const showIt = filter.rows.includes($row)
				$row.classList.toggle('hide', !showIt)
				if (showIt) {
					showCount++
				}
			})
			$showMore.classList.toggle('show', (showCount > MAX_SHOW) && !showAll)
			$categoryBlock.style.display = 'none'
			$headerIntro.classList.add('hide')
			$headerFiltered.classList.remove('hide')
			$headerFiltered.querySelector('h2').innerText = `Viewing: ${filter.name}`
			$headerBlock.classList.add('hide-post')
		}

		const doReset = () => {
			eachRow(($row) => {
				$row.classList.remove('hide')
			})
			$categoryBlock.style.display = ''
			$headerIntro.classList.remove('hide')
			$headerFiltered.classList.add('hide')
			$headerBlock.classList.remove('hide-post')
			$showMore.classList.toggle('show', $rows.length > MAX_SHOW && !showAll)
		}

		const findFilter = () => {
			const slug = window.location.hash.replace('#', '')
			if (categories[slug]) {
				doFilter(categories[slug])
			} else if (tags[slug]) {
				doFilter(tags[slug])
			} else {
				doReset() 
			}
		}

		initData()
		
		$showMore.addEventListener('click', (ev) => {
			showAll = true;
			$newsBlock.classList.add('show-all')
			$showMore.classList.remove('show')
		})
		
		addEventListener('hashchange', (ev) => {
			ev.preventDefault()
			showAll = true;
			$newsBlock.classList.add('show-all')
			$showMore.classList.remove('show')
			findFilter()
		})


		if (window.location.hash) {
			showAll = true;
			$newsBlock.classList.add('show-all')
			$showMore.classList.remove('show')
			findFilter()
		}
	}

	return {
		init: init,
		name: 'news-header'
	};
})();
